import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from "../../constants/api";
import { format } from "date-fns";
import { ApprovedRecipePageContext } from "../../App";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { Tooltip } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import { RecipeTabContext } from "../../pages/recipes/AllRecipesPage";

const AllApprovedRecipesLayer = () => {
  const [records, setRecords] = useState([]);
  const [data, setData] = useState(null);
  const token = localStorage.getItem("pfp-token");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [activeModal, setActiveModal] = useState(null);
  const [update, setUpdate] = useState(0);
  const { approvedRecipePage, setApprovedRecipePage } = useContext(
    ApprovedRecipePageContext
  );
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [search, setSearch] = useState("");
  const [reasons, setReason] = useState("");
  const {updateTab, setUpdateTab} = useContext(RecipeTabContext)

  // Trigger the modal by setting the active row's ID
  const handleModalOpen = (id) => {
    setActiveModal(id);
  };

  // Close the modal
  const handleModalClose = () => {
    setActiveModal(null);
  };

  useEffect(() => {
    const fetchAllRecipes = async () => {
      if (search.trim() !== "") {
        await setLimit(10);
        await setApprovedRecipePage(1);
      }

      try {
        setLoading(true);

        const searchParams = new URLSearchParams({
          offset: approvedRecipePage,
          limit: limit,
          search_term: search,
          is_approved: "approved",
        });
        const response = await fetch(
          `${API_URL}/api/backend/recipes/list?${searchParams}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const json = await response.json();

        if (response.ok) {
          const sortedData = json.data.sort(
            (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
          );
          setRecords(sortedData);
          setData(sortedData);
          setLastPage(json.pagination.last_page);
          setTotal(json.pagination.total);
        } else {
          setRecords([]);
        }
      } catch (error) {
        alert(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllRecipes();
  }, [update, limit, approvedRecipePage, search, updateTab]);

  const handleDelete = (myId) => {
    console.log(myId);
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-sm ms-2",
        cancelButton: "btn btn-sm",
        popup: "my-custom-modal",
        title: "my-custom-title",
        icon: "my-custom-icon",
        content: "my-custom-text",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          const deleteUser = async (d_id) => {
            const response = await fetch(
              `${API_URL}/api/backend/recipes/delete/${d_id}`,
              {
                method: "DELETE",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            setUpdate(update + 1);
          };
          deleteUser(myId);
          swalWithBootstrapButtons.fire({
            title: "Deleted!",
            text: "Recipe has been deleted.",
            icon: "success",
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire({
            title: "Cancelled",
            text: "Recipe is safe :)",
            icon: "error",
          });
        }
      });
  };
  const handleApprove = async (approved, id) => {
    const data = approved === "rejected" ? { approved, reasons } : { approved };

    const response = await fetch(
      `${API_URL}/api/backend/recipes/approval/${id}`,
      {
        method: "PATCH",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "Application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const json = await response.json();

    if (response.ok) {
      toast.success(json.message);
      setUpdate(update + 1);
      if (approved === "rejected") {
        handleModalClose();
      }
    }
  };

  useEffect(() => {
    const tooltipButtons = document.querySelectorAll(".my-tooltip-button");

    const tooltipInstances = Array.from(tooltipButtons).map((tooltipButton) => {
      const tooltipContent = tooltipButton.nextElementSibling?.innerHTML || "";

      return new Tooltip(tooltipButton, {
        title: tooltipContent,
        trigger: "hover",
        html: true,
        customClass: tooltipButton.getAttribute("data-bs-custom-class") || "",
      });
    });

    // Cleanup tooltips when the component unmounts
    return () => {
      tooltipInstances.forEach((tooltip) => tooltip.dispose());
    };
  }, [records]); // Add dependency to ensure it re-runs when `records` change.

  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex flex-wrap align-items-center gap-3">
          {activeModal && (
            <div
              className="modal fade show"
              tabIndex={-1}
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
              style={{ display: "block", backdropFilter: "blur(5px)" }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <form
                  className="modal-content"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleApprove("rejected", activeModal);
                  }}
                >
                  <div className="card">
                    <div className="card-header d-flex">
                      <h5 className="card-title mb-0">Reason</h5>
                      <button
                        type="button"
                        className="btn-close ms-auto"
                        onClick={handleModalClose}
                      ></button>
                    </div>
                    <div className="card-body">
                      <div className="row gy-3">
                        <div className="col-12">
                          <textarea
                            type="text"
                            name="#0"
                            className="form-control"
                            placeholder="Explain reason of rejection"
                            onChange={(e) => setReason(e.target.value)}
                            rows={5}
                            required
                          />
                        </div>

                        <div className="col-12 d-flex justify-content-end">
                          <button type="submit" className="btn btn-danger-600">
                            Confirm Rejection
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}

          <div className="d-flex align-items-center gap-2">
            <span>Show</span>
            <select
              className="form-select form-select-sm w-auto"
              defaultValue={limit}
              onChange={(e) => setLimit(parseInt(e.target.value))}
            >
              <option value={limit} disabled>
                {limit}
              </option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          <div className="icon-field">
            <input
              type="text"
              name="#0"
              className="form-control form-control-sm w-auto"
              placeholder="Search"
              onChange={(e) => setSearch(e.target.value)}
            />
            <span className="icon">
              <Icon icon="ion:search-outline" />
            </span>
          </div>
        </div>
      </div>

      <div className="card-body p-24">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr>
                <th scope="col">
                  <div className="d-flex align-items-center gap-10">
                    <div className="form-check style-check d-flex align-items-center"></div>
                    ID
                  </div>
                </th>

                <th scope="col">Image</th>
                <th scope="col">User</th>
                <th scope="col">Name</th>
                <th scope="col">Category</th>
                <th scope="col" className="text-center">
                  Status
                </th>
                <th scope="col" className="dt-orderable-asc dt-orderable-desc">
                  Date Approved
                </th>
                <th scope="col" className="text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {records &&
                records.map((user) => (
                  <tr key={user.id}>
                    <td>
                      <div className="d-flex align-items-center gap-10">
                        {user.id}
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        {user.files.length > 0 ? (
                          <img
                            src={
                              user.files[0]
                                ? user.files[0].cdn_image_small
                                : "no image"
                            }
                            className="w-120-px h-80-px radius-8 object-fit-cover"
                            alt="Avatar"
                          />
                        ) : (
                          <img
                            src="assets/images/avatar/avatar2.png"
                            className="w-120-px h-80-px radius-8 object-fit-cover"
                            alt="Avatar"
                          />
                        )}
                      </div>
                    </td>
                    <td>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {user.user_name}
                      </span>
                    </td>

                    <td>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {user.recipe_name}
                      </span>
                    </td>
                    <td>
                      <div className="">
                        <span
                          className="my-tooltip-button badge text-sm fw-semibold text-primary-600 bg-primary-100 px-20 py-9 radius-4 text-white"
                          type="button"
                          data-bs-toggle="tooltip"
                          data-bs-html="true"
                          data-bs-custom-class="tooltip-primary"
                          title="Tooltip Content Example"
                        >
                          View
                        </span>

                        <div className="my-tooltip tip-content hidden">
                          {/* <h6 className="text-white">
                            Tooltip Title {user.id}
                          </h6> */}
                          <ul>
                            {user.recipe_categories &&
                              user.recipe_categories.map((cat) => (
                                <li>{cat.recipe_category_name}</li>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </td>
                    <td className="text-center">
                      {user.active === 1 ? (
                        <span className="bg-success-focus text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm">
                          Active
                        </span>
                      ) : (
                        <span className="bg-neutral-200 text-neutral-600 border border-neutral-400 px-24 py-4 radius-4 fw-medium text-sm">
                          Inactive
                        </span>
                      )}
                    </td>
                    <td>{format(user.updated_at, "dd MMM, yyyy")}</td>
                    <td className="text-center">
                      <div className="d-flex align-items-center gap-10 justify-content-center">
                        <button
                          type="button"
                          className="bg-info-100 text-info-500 bg-hover-info-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                        >
                          <Icon
                            icon="material-symbols:pending-outline"
                            className="icon text-xl"
                            onClick={() => handleApprove("pending", user.id)}
                          />
                        </button>
                        <button
                          type="button"
                          onClick={() => handleDelete(user.id)}
                          className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                        >
                          <Icon
                            icon="fluent:delete-24-regular"
                            className="menu-icon"
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
          <span>
            Showing {limit} of {total} entries
          </span>
          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
            {approvedRecipePage > 1 ? (
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px  text-md"
                  onClick={
                    approvedRecipePage > 1
                      ? () => setApprovedRecipePage(approvedRecipePage - 1)
                      : () => setApprovedRecipePage(approvedRecipePage)
                  }
                >
                  <Icon icon="ep:d-arrow-left" className="" />
                </button>
              </li>
            ) : (
              <></>
            )}

            {approvedRecipePage > 2 ? (
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                  onClick={() => setApprovedRecipePage(approvedRecipePage - 2)}
                >
                  {approvedRecipePage - 2}
                </button>
              </li>
            ) : (
              <></>
            )}
            {approvedRecipePage > 1 ? (
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                  onClick={() => setApprovedRecipePage(approvedRecipePage - 1)}
                >
                  {approvedRecipePage - 1}
                </button>
              </li>
            ) : (
              <></>
            )}

            <li className="page-item">
              <Link
                className="page-link text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md bg-primary-600 text-white"
                to="#"
              >
                {approvedRecipePage}
              </Link>
            </li>

            {approvedRecipePage < lastPage ? (
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                  onClick={() => setApprovedRecipePage(approvedRecipePage + 1)}
                >
                  {approvedRecipePage + 1}
                </button>
              </li>
            ) : (
              <></>
            )}
            {approvedRecipePage + 1 < lastPage ? (
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                  onClick={() => setApprovedRecipePage(approvedRecipePage + 2)}
                >
                  {approvedRecipePage + 2}
                </button>
              </li>
            ) : (
              <></>
            )}
            {approvedRecipePage !== lastPage ? (
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px  text-md"
                  onClick={() => setApprovedRecipePage(approvedRecipePage + 1)}
                >
                  {" "}
                  <Icon icon="ep:d-arrow-right" className="" />{" "}
                </button>
              </li>
            ) : (
              <></>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AllApprovedRecipesLayer;
